import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from './errorHandler.service';
import { Observable, of } from 'rxjs';
import { config } from '../config';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';
import { Cacheable } from 'ngx-cacheable';

@Injectable({
  providedIn: 'root'
})
export class VehicleSpeedEventService {

  constructor(
    private http: HttpClient,
    private handleError: ErrorHandlerService,private router: Router) { }

  getSpeedEventAll(options): Observable<[]> {

    let params = new HttpParams()
    .set("building", options.building)
    .set("floor", options.floor)
    .set("unit", options.unit)
    .set("license", options.license)
    .set("veicleRfid", options.rfid)
    .set("startAt", options.startAt)
    .set("endAt", options.endAt)
    .set("accessPointIds", options.accessPointIds)
    .set("speedExceeded", options.speedExceeded)
    .set("higherOrLowerSpeed", options.higherOrLowerSpeed)
    .set("speedKmh", options.speedKmh)
    .set("page", options.page)
    .set("nameDocRfid", options.nameDocRfid)
    .set("itemsPerPage", options.itemsPerPage)
    .set("manufacturer", options.manufacturer)
    .set("model", options.model)
    .set("color", options.color)
    .set("viewSensitiveUserData", options.viewSensitiveUserData)
    .set("geolocation", options.geolocation)

    return this.http.get<any>(`${config.apiUrl}/VehicleSpeedEvent/filtered`, { params: params })
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          if (error.message == 'Timeout has occurred') {
            this.handleError.toastTimeout('Demora na comunicação com servidor');
          }
          return of([]);
        }));
  }

  getSpeedDetailSnapshot(d: Date, id: number): Observable<[]> {
    let params = new HttpParams()
      .set("d", d.toString())
      .set("id", id.toString());
    return this.http.get<any>(`${config.apiUrl}/VehicleSpeedEvent/speedDetailSnapshot`, { params: params })
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível resgatar os dados no servidor');
          return of([]);
        }));
  }
      

  getSpeedDetailSnapshotImgUrl(d: Date, id: number) {
    return `./api/v2/VehicleSpeedEvent/speedDetailSnapshotImg?d=${d.toString()}&id=${id}`
  }
  
  getSpeedSnapshot(d: Date, id: number): Observable<[]> {
    let params = new HttpParams()
      .set("d", d.toString())
      .set("id", id.toString());
    return this.http.get<any>(`${config.apiUrl}/VehicleSpeedEvent/speedSnapshot`, { params: params })
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível resgatar os dados no servidor');
          return of([]);
        }));
  }
      
  getSpeedSnapshotImgUrl(d: Date, id: number) {
    return `./api/v2/VehicleSpeedEvent/speedSnapshotImg?d=${d.toString()}&id=${id}`
  }

  // @Cacheable({
  //   maxCacheCount: 1, // Limita o cache a 1 entrada única. Se mais chamadas forem feitas, as antigas podem ser descartadas
  //   maxAge: 300000, // Define o tempo máximo de vida de uma entrada no cache
  // })
  getSpeedingEvents(): Observable<[]> {
  return this.http.get<any>(`${config.apiUrl}/VehicleSpeedEvent/speedingEvents`)
    .pipe(timeout(Wait),
      tap(resp => resp),
      catchError(error => {
        console.log(error.error);
        this.handleError.popupError(error, 'Falha na comunicação com o servidor...', 'Não foi possível resgatar os dados no servidor');
        return of([]);
      }));
  }
}
